import BaseAPI from "../api";

const path: string = "strategies";

export interface createStrategy {
  strategyNo: string;
  strategyName: string;
  strategyDesc: string;
  strategyStatus: string;
  idFiscalYear: number;
  idStrategyRef: number;
}
export interface updateStrategy {
  strategyNo: string;
  strategyName: string;
  strategyDesc: string;
  strategyStatus: string;
  idFiscalYear: number;
  idStrategyRef: number;
}
export interface getStrategy {
  idFiscalYear?:number;
  keyword?: string;
  limit?: number;
  page?: number;
}

export class StrategyApi extends BaseAPI {
  public static createStrategy(props: createStrategy): Promise<any> {
    return this.api.post(`${path}`, props).then((res) => res);
  }
  public static getStrategy(props: getStrategy): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  public static updateStrategy(
    idStrategy: number,
    props: updateStrategy
  ): Promise<any> {
    return this.api.patch(`${path}/${idStrategy}`, props).then((res) => res);
  }
  public static getDetailStrategy(idStrategy: number): Promise<any> {
    return this.api.get(`${path}/${idStrategy}`).then((res) => res);
  }
}
